interface Props {
    width?: number;
    height?: number;
    hexColor?: string;
}

export const ProfileIcon = ({
    width = 20,
    height = 20,
    hexColor = 'black',
}: Props) => {
    return (
        <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.5 16.6667C4.44649 14.6021 7.08918 13.3333 10 13.3333C12.9108 13.3333 15.5535 14.6021 17.5 16.6667M13.75 6.25C13.75 8.32107 12.0711 10 10 10C7.92893 10 6.25 8.32107 6.25 6.25C6.25 4.17893 7.92893 2.5 10 2.5C12.0711 2.5 13.75 4.17893 13.75 6.25Z" stroke={hexColor} strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

export default ProfileIcon;
